import image1 from "../../assets/user.png";
import swasti from "../../assets/swasti.png";
import sp from "../../assets/SoumyajitPaul.png";
import ib from "../../assets/IshikaBhattacharjee.png";
import rn from "../../assets/Rohit Nagar.png";
import sa from "../../assets/Soumyadeep Anand.png"
import ds from "../../assets/Dipankar Sahu.png"
import uk from "../../assets/Uk.png"
import pj from "../../assets/pj.png"
import bp from "../../assets/Biswajeet Pasayat.jpg"
import vm from "../../assets/V Mohitha.png"
import piyush from "../../assets/piyush.png"
import mehedi from "../../assets/mehedi.png"
import sudip from "../../assets/DP.png";
import ad from "../../assets/asuthosh.png"
import ska from "../../assets/SHREYASH.png"
import sks from "../../assets/sandeep.png"
const data = [
  {
    id: 1,
    name: "Soumyadeep Anand",
    position: "Optix Coordinator",
    img: sa,
  },
  {
    id: 2,
    name: "Utkarsh Keerti",
    position: "Coordinator(Konnexions)",
    img: uk,
    
  },
  {
    id: 3,
    name: "Swasti Mishra",
    position: "Asst. Coordinator(Konnexions)",
    img: swasti,
    
  },
  {
    id: 4,
    name: "Priyanshu Jha",
    position: "Asst. Coordinator(Konnexions)",
    img: pj,
    
  },
  {
    id: 5,
    name: "Biswajeet Pasayat",
    position: "Member(Optix)",
    img: bp,
   
  },
  {
    id: 6,
    name: "V Mohitha ",
    position: "Member(Optix)",
    img: vm,
    
  },
  {
    id: 7,
    name: "Rohit Nagar",
    position: "Member(Optix)",
    img: rn,
  },
  {
    id: 8,
    name: "Ishika Bhattacharjee",
    position: "Member(Optix)",
    img: ib,
    
  },
  {
    id: 9,
    name: "Dipankar Sahu",
    position: "Member(Optix)",
    img: ds, 
    
  },

  {
    id: 10,
    name: "Soumyajit Paul",
    position: "Member(Optix)",
    img: sp,    
  },
  {
    id: 11,
    name: "Piyush Raj Singh",
    position: "Member(Konnexions)",
    img: piyush,    
  },
  {
    id:12,
    name:"Md Mehedi Hasan",
    position:"Member(Konnexions)",
    img:mehedi,
  },
  {
    id:13,
    name:"Sudip Chanda",
    position:"Member(Konnexions)",
    img:sudip,
  },
  {
    id:14,
    name:"Asuthosh Dash",
    position:"Member(Konnexions)",
    img:ad,
  },
  {
    id:15,
    name:"Shreyash kumar agnihotri",
    position:"Member(Konnexions)",
    img:ska,
  },
  {
  id:16,
  name:"Sandeep Kumar Swain",
  position:"Member(Konnexions)",
  img:sks,
  
},

];

export default data;
